import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { Applayout } from "./routes/AppRoutes";
import { ToastContainer } from "react-toastify";
import Loading from "./components/Loading";
import "./styles/global.css";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const savedLang = localStorage.getItem("lang");

    try {
      const parsedLang = savedLang ? JSON.parse(savedLang) : null;
      if (!parsedLang || (parsedLang !== "en" && parsedLang !== "ar")) {
        localStorage.setItem("lang", JSON.stringify("en"));
      }
    } catch (error) {
      localStorage.setItem("lang", JSON.stringify("en"));
    }
  }, []);

  const handleLoadingComplete = () => {
    console.log('handleLoadingComplete called, setting isLoading to false');
    setIsLoading(false);
  };

  if (isLoading) {
    return <Loading onLoadingComplete={handleLoadingComplete} />;
  }

  return (
    <BrowserRouter>
      <ToastContainer autoClose={3000} hideProgressBar={false} />
      <Applayout />
    </BrowserRouter>
  );
}

export default App;
